import { render } from "./TestTrumpetStart.vue?vue&type=template&id=5d0f1618&scoped=true"
import script from "./TestTrumpetStart.vue?vue&type=script&lang=js"
export * from "./TestTrumpetStart.vue?vue&type=script&lang=js"

import "./TestTrumpetStart.vue?vue&type=style&index=0&id=5d0f1618&scoped=true&lang=css"

import exportComponent from "D:\\eazyc\\ezDev\\ECS-Cognitive\\cognitive-screening-mobile-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d0f1618"]])

export default __exports__